
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/policies/deliveryPolicy",
      function () {
        return require("private-next-pages/footerItems/policies/deliveryPolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/policies/deliveryPolicy"])
      });
    }
  